// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hints-and-keypoints-modal .card {\n  align-items: flex-start;\n  justify-content: center;\n  display: flex;\n  margin-bottom: 2rem;\n}\n.hints-and-keypoints-modal .card .icon-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: var(--v-secondary-base);\n  float: left;\n  margin-right: 2rem;\n  padding: 12px;\n  font-size: 21px;\n}", ""]);
// Exports
module.exports = exports;
